import * as styles from "./NDSSurveyHeader.module.scss";

import React, { useMemo } from "react";
import { useNationalDogSurveyContext } from "../../NationalDogSurvey/NationalDogSurvey.context";
import { Chevron } from "../common/Icons";
import { NDSSurveyHeaderProgressBar } from "./NDSSurveyHead.components";

export const NDSSurveyHeader: React.FC = () => {
	const {
		surveyState: { surveyProgress },
		screenState,
	} = useNationalDogSurveyContext();
	const [showAllSections, setShowAllSections] = React.useState(false);

	const segments = useMemo(
		() =>
			"THOUGHTS_ON_DOGS" in surveyProgress
				? [
						{
							title: "Thoughts on dogs",
							progress: surveyProgress.THOUGHTS_ON_DOGS,
						},
						{
							title: "About you",
							progress: surveyProgress.ABOUT_YOU,
						},
					]
				: [
						{
							title: "About your dog",
							progress: surveyProgress.ABOUT_YOUR_DOGS,
						},
						{
							title: "Choosing your dog",
							progress: surveyProgress.CHOOSING_YOUR_DOG,
						},
						{
							title: "Understanding your dog",
							progress: surveyProgress.UNDERSTANDING_YOUR_DOG,
						},
						{
							title: "Relationship with your dog",
							progress: surveyProgress.RELATIONSHIP_WITH_YOUR_DOG,
						},
						{
							title: "About you",
							progress: surveyProgress.ABOUT_YOU,
						},
					],
		[surveyProgress],
	);

	const mainDogPosition = useMemo(() => {
		if ("THOUGHTS_ON_DOGS" in surveyProgress) {
			switch (screenState.route) {
				case "THOUGHTS_ON_DOGS":
					return 0;
				case "ABOUT_YOU":
					return 1;
				default:
					return -1;
			}
		}
		switch (screenState.route) {
			case "ABOUT_YOUR_DOGS": {
				return 0;
			}
			case "CHOOSING_YOUR_DOG": {
				return 1;
			}
			case "UNDERSTANDING_YOUR_DOG": {
				return 2;
			}
			case "RELATIONSHIP_WITH_YOUR_DOG": {
				return 3;
			}
			case "ABOUT_YOU": {
				return 4;
			}
			case "SUBSEQUENT_DOG": {
				return 4;
			}
		}
	}, [screenState, surveyProgress]);

	if (
		screenState.route === "WARM" ||
		["LOADING", "THANK_YOU", "AYD_NOD_INTRO", "Q1"].includes(screenState.screen)
	)
		return null;

	return (
		<div className={styles.surveyHeader}>
			<div className={styles.surveySections}>
				{segments.map(
					(segment, i) =>
						segment && (
							<div
								key={segment.title}
								className={
									segment.progress < 0
										? styles.surveyHeaderSegmentInactive
										: styles.surveyHeaderSegment
								}
								data-is-open={mainDogPosition === i || showAllSections}
								aria-hidden={mainDogPosition !== i}
							>
								<div className={styles.surveyHeaderSegmentTitle}>
									{segment.title}
								</div>
								<output
									aria-label={`Progress for ${segment.title} is ${segment.progress}%`}
									className={styles.surveyHeaderSegmentProgress}
									aria-live="polite"
								>{`${Math.max(segment.progress, 0)}%`}</output>
								{((!showAllSections && mainDogPosition === i) ||
									(showAllSections && i === 0)) && (
									<button
										type="button"
										className={styles.surveyHeaderSegmentIcon}
										aria-expanded={showAllSections}
										aria-label={
											showAllSections
												? "Close progress menu"
												: "Open progress menu"
										}
										onClick={() => setShowAllSections(!showAllSections)}
									>
										{
											<Chevron
												height={"24px"}
												rotation={showAllSections ? 0 : 180}
											/>
										}
									</button>
								)}
							</div>
						),
				)}
			</div>
			<div className={styles.progressContainer} aria-hidden>
				<NDSSurveyHeaderProgressBar />
			</div>
		</div>
	);
};

export default NDSSurveyHeader;
